var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.182,
    height: 18,
    viewBox: "0 0 26.182 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(0 -7.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(0 7.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M26.182,16.5s-4.909-9-13.091-9S0,16.5,0,16.5s4.909,9,13.091,9S26.182,16.5,26.182,16.5Zm-24.262,0a21.49,21.49,0,0,1,2.716-3.343c2.106-2.109,4.986-4.021,8.455-4.021s6.347,1.911,8.457,4.021A21.49,21.49,0,0,1,24.264,16.5c-.095.142-.2.3-.319.471a21.579,21.579,0,0,1-2.4,2.872c-2.109,2.109-4.989,4.021-8.457,4.021s-6.347-1.911-8.457-4.021A21.492,21.492,0,0,1,1.918,16.5Z",
    transform: "translate(0 -7.5)",
    fill: "#00a3ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M19.227,15.136a4.091,4.091,0,1,0,4.091,4.091,4.091,4.091,0,0,0-4.091-4.091ZM13.5,19.227a5.727,5.727,0,1,1,5.727,5.727A5.727,5.727,0,0,1,13.5,19.227Z",
    transform: "translate(-6.136 -10.227)",
    fill: "#00a3ae"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.9a6b89763b491e62a8a4ba1715914dd6.svg";
export { ForwardRef as ReactComponent };